module.exports = __webpack_public_path__ + "static/img/search_on.13b4633b.svg";